// extracted by mini-css-extract-plugin
export default {"main_container":"AppContainer_main_container__z8nYf","header":"AppContainer_header__GNye4","content":"AppContainer_content__zBlHD"};